import { useQuery } from '@tanstack/react-query'
import { getLedShifts } from 'api/shift'
import { QueryFnParams, QueryOptions } from 'queries/types'
import { ledShiftsKey } from './keys'

export function useLedShifts(
  params: Partial<QueryFnParams<typeof getLedShifts>[0]>,
  options: QueryOptions<typeof getLedShifts> = {}
) {
  const { companyId, shiftId } = params

  return useQuery({
    refetchInterval: 60000, // refresh every 60s, same as the shift detail query
    ...options,
    queryKey: ledShiftsKey(shiftId),
    queryFn: ({ signal }) => {
      if (!companyId || !shiftId) {
        throw new Error('Company and shift are required')
      }
      return getLedShifts({ companyId, shiftId }, signal)
    },
    enabled: !!companyId && !!shiftId && (options.enabled ?? true),
  })
}
